<template>
    <v-container
      fluid
      class="full-height-with-navbar"
    >
      <div class="tabs-bar">
        <v-layout
          align-center
          v-if="!summary"
        >
          <!-- <v-icon
            class="icon--link"
            @click="translatePrev"
          >
            chevron_left
          </v-icon> -->
          <v-flex
            d-flex
            class="tabs__wrapper"
          >
            <div
              class="tabs__container tabs__container--overflow"
              :style="`transform: translateX(${translateWidth}px)`"
            >
              <div
                class="tabs__div "
                v-ripple
                v-for="(tab, i) in tabs"
                :key="i"
                @click="model = `tab-${i}`"
                :ref="`tab-${i}`"
              >
              <span
                class="tabs__item"
                :class="{'tabs__item--active': model === `tab-${i}`}"
              >{{ tab.title }}</span>
              </div>
            </div>

          </v-flex>
        </v-layout>
      </div>

      <div
        class="tabs-content"
      >
        <transition name="component-fade" mode="out-in">
          <component
            :is="tabComponent"
          />
        </transition>
      </div>
    </v-container>
</template>
<script>
import Campaigns from './campaigns/Index.vue'
import AdSets from './adsets/Index.vue'
import Ads from './ads/Index.vue'
export default {
  name: 'campaigns',
  components: {
    Campaigns,
    AdSets,
    Ads
  },
  data () {
    return {
      model: 'tab-0',
      summary: false,
      tabs: [
        {
          title: 'Campaigns'
        },
        {
          title: 'Ad Sets'
        },
        {
          title: 'Ads'
        }
      ],
      translateWidth: 0,
      counter: 0
    }
  },
  computed: {
    tabComponent () {
      switch (this.model) {
        case 'tab-0':
          return 'Campaigns'
        case 'tab-1':
            return 'AdSets'
        case 'tab-2':
            return 'Ads'
        default:
          return 'Campaigns'
      }
    }
  },
  methods: {
    translatePrev () {
      if (this.counter > 0) {
        this.translateWidth = 0
        this.counter = 0
      }
    },
    translateNext () {
      const element = this.$refs[`tab-${this.counter}`]
      const elWidth = element[0].getBoundingClientRect().width
      if (this.counter < 5) {
        this.translateWidth -= elWidth
        this.counter++
      }
    }
  }
}
</script>
<style lang="scss">
  $border-color: rgb(236, 243, 247);
  .tabs-content {
    width: 100%;
    height: 100%;
    display: flex;
    flex: 1 1 auto;

    &__container {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      &-action {
        width: 100%;
        border-top: 1px solid $border-color;
        align-items: end;
        padding: .5rem;
        flex: none;
      }
    }
  }
  .component-fade-enter-active {
    transition: transform .3s ease;
  }
  .component-fade-enter {
    transform: translateX(500px);
  }
</style>
